import styled from 'styled-components';
export const Container = styled.div `
  border-radius: var(--radius-brand);
  padding: 24px 28px;
  background: var(--bg-secondary);
`;
export const Subtitle = styled.h4 `
  color: var(--text-secondary);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`;
